import React, { useState, useEffect, Children } from "react";
import { EmployeeTeamVM } from "../../Models/ViewModels";
import {
  Table,
  Pagination,
  Stack,
  Avatar,
  Input,
  Button,
  Toggle,
} from "rsuite";
import * as TeamDB from "../../Services/EmployeeDB";
import { PageHeader } from "../../SharedComponents/PageHeader";

import { TeamDetailSimple } from "./TeamDetailSimple";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { Modal } from "react-bootstrap";
import { TeamMembers } from "./TeamMembers";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { GetTotalProcessBuffer } from "../../Services/KRAApprovalDB";
import { ProcessBufferAlte } from "./ProcessBufferAlte";
import { ProcessTeamMembers } from "./ProcessTeamMembers";
const { Column, HeaderCell, Cell, ColumnGroup } = Table;
const colors = ["pink", "grey", "blue", "yellow", "purple", "green", "red"];

export const ProcessBuffer = ({ name, designation, department }: any) => {
  const proc: any = [];
  const proc1: any = [];
  const [cachedTeamList, setCachedTeamList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [processName, setProcessName] = useState(new Array<EmployeeTeamVM>());
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredTeamList, setFilteredTeamList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [checked, setChecked] = useState(false);
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [popup, setPopUp] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [searching, setSearching] = useState(false);
  const [total, setTotal] = useState(new Array<EmployeeTeamVM>());

  useEffect(() => {
    getAllTeamList(loginid);
  }, []);

  const handleClose = () => setPopUp(false);
  const filterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredTeamList(
        cachedTeamList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredTeamList([...cachedTeamList]);
      setSearching(false);
    }
  };

  const tableDataFeed = filteredTeamList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getFTEBuff = (processesArray: any[], processName: string) => {
    for (let i = 0; i < processesArray.length; i++) {
      if (processesArray[i].ProcessName === processName) {
        return processesArray[i].FTEBuff;
      }
    }
    return "";
  };

  const getAllProcessBuffer = (loginid: any) => {
    GetTotalProcessBuffer(loginid)
      .then((res: EmployeeTeamVM[] | any) => {
        if (res) {
          res = res.data;
          setTotal(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllTeamList = (loginid: any) => {
    TeamDB.GetTeamDetails(loginid)
      .then((res: EmployeeTeamVM[] | any) => {
        if (res) {
          res = res.data;
          for (let i = 0; i < res.length; i++) {
            res[i].Total =
              +getFTEBuff(res[i].Processes, "AR") +
              +getFTEBuff(res[i].Processes, "ALL") +
              +getFTEBuff(res[i].Processes, "Coding") +
              +getFTEBuff(res[i].Processes, "Credentialing") +
              +getFTEBuff(res[i].Processes, "PP") +
              +getFTEBuff(res[i].Processes, "Demo") +
              +getFTEBuff(res[i].Processes, "Denials") +
              +getFTEBuff(res[i].Processes, "NA") +
              +getFTEBuff(res[i].Processes, "Others") +
              +getFTEBuff(res[i].Processes, "CP") +
              +getFTEBuff(res[i].Processes, "Statements") +
              +getFTEBuff(res[i].Processes, "PFS");

            res[i].ALLFTEBuffer = +getFTEBuff(res[i].Processes, "ALL");

            res[i].ARFTEBuffer = +getFTEBuff(res[i].Processes, "AR");

            res[i].CodingFTEBuffer = +getFTEBuff(res[i].Processes, "Coding");

            res[i].CPFTEBuffer = +getFTEBuff(res[i].Processes, "CP");

            res[i].DemoFTEBuffer = +getFTEBuff(res[i].Processes, "Demo");

            res[i].DenialsFTEBuffer = +getFTEBuff(res[i].Processes, "Denials");

            res[i].CredentialingFTEBuffer = +getFTEBuff(
              res[i].Processes,
              "Credentialing"
            );

            res[i].NAFTEBuffer = +getFTEBuff(res[i].Processes, "NA");

            res[i].OtherFTEBuffer = +getFTEBuff(res[i].Processes, "Other");

            res[i].PFSFTEBuffer = +getFTEBuff(res[i].Processes, "PFS");

            res[i].PPFTEBuffer = +getFTEBuff(res[i].Processes, "PP");

            res[i].StatementsFTEBuffer = +getFTEBuff(
              res[i].Processes,
              "Statements"
            );
          }
          setCachedTeamList(res);
          setFilteredTeamList(res);
          setLoading(false);
          getAllProcessBuffer(loginid);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setTimeout(() => {
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return cachedTeamList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };
  const handelDetailsPopUp = (
    processName: any,
    teamName: any,
    loginid: any
  ) => {
    TeamDB.GetProcessMembersDetails(processName, teamName, loginid).then(
      (res) => {
        setTeamMembers(res.data);
        setPopUp(true);
      }
    );
  };
  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <PageHeader title="Team Process Buffer Details (FTE)" backPage="">
            <></>
          </PageHeader>
        </div>
        {!checked ? (
          <div className="col-md-3">
            <Input
              className="form-control w-100 "
              type="search"
              autoFocus={true}
              placeholder={"Search team...."}
              onChange={filterData}
            />
          </div>
        ) : (
          <div className="col-md-3 "></div>
        )}
        {!checked ? (
          <div className="col-md-1">
            {searching == true ? (
              <button
                id="color"
                onClick={() => handleDownloadAsExcel(tableDataFeed)}
              >
                <BootstrapIcon
                  bootStrapIconName={"file-earmark-arrow-down-fill"}
                  size={30}
                  cssClasses={"pe-2"}
                />{" "}
              </button>
            ) : (
              <button
                id="color"
                onClick={() => handleDownloadAsExcel(cachedTeamList)}
              >
                <BootstrapIcon
                  bootStrapIconName={"file-earmark-arrow-down-fill"}
                  size={30}
                  cssClasses={"pe-2"}
                />{" "}
              </button>
            )}
          </div>
        ) : (
          <div className="col-md-2"></div>
        )}
        <hr />
      </div>

      {!checked ? (
        <div>
          <Modal show={popup} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Team Members</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ProcessTeamMembers members={teamMembers} />
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-danger" onClick={handleClose}>
                Close
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleDownloadAsExcel(teamMembers)}
              >
                Export To Excel
              </button>
            </Modal.Footer>
          </Modal>
          <div className="show-container">
            {total.length > 0 ? (
              <Table
                id="table"
                height={350}
                data={tableDataFeed}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
                loading={isLoading}
                bordered={true}
                cellBordered={true}
                className="border border-dark mt-2"
                rowHeight={32}
                headerHeight={30}
              >
                <Column flexGrow={270} align="left" resizable sortable>
                  <CustomTableHeaderCell placement={"Team"}>
                    Team
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: any) => {
                      return <p>{rowData.Team}</p>;
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={70} resizable>
                  <CustomTableHeaderCell placement={"ALL"}>
                    {" "}
                    ALL({total[0].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <p
                          onClick={() => {
                            handelDetailsPopUp("ALL", rowData.Team, loginid);
                          }}
                        >
                          {rowData.ALLFTEBuffer}
                        </p>
                      );
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={60} resizable>
                  <CustomTableHeaderCell placement={"AR"}>
                    AR ({total[1].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0"
                          onClick={() => {
                            handelDetailsPopUp("AR", rowData.Team, loginid);
                          }}
                        >
                          {rowData.ARFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={90} resizable>
                  <CustomTableHeaderCell placement={"Coding"}>
                    {" "}
                    Coding ({total[2].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0 "
                          onClick={() => {
                            handelDetailsPopUp("Coding", rowData.Team, loginid);
                          }}
                        >
                          {rowData.CodingFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={70} resizable>
                  <CustomTableHeaderCell placement={"CP"}>
                    CP ({total[3].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0 "
                          onClick={() => {
                            handelDetailsPopUp("CP", rowData.Team, loginid);
                          }}
                        >
                          {rowData.CPFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>

                <Column flexGrow={130} resizable>
                  <CustomTableHeaderCell placement={"Credentialing"}>
                    Credentialing ({total[4].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0"
                          onClick={() => {
                            handelDetailsPopUp(
                              "Credentialing",
                              rowData.Team,
                              loginid
                            );
                          }}
                        >
                          {rowData.CredentialingFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>

                <Column flexGrow={90} resizable>
                  <CustomTableHeaderCell placement={"Demo"}>
                    Demo ({total[5].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0 "
                          onClick={() => {
                            handelDetailsPopUp("Demo", rowData.Team, loginid);
                          }}
                        >
                          {rowData.DemoFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={80} resizable>
                  <CustomTableHeaderCell placement={"Denials"}>
                    Denials ({total[6].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0 "
                          onClick={() => {
                            handelDetailsPopUp(
                              "Denials",
                              rowData.Team,
                              loginid
                            );
                          }}
                        >
                          {rowData.DenialsFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>

                <Column flexGrow={65} resizable>
                  <CustomTableHeaderCell placement={"PFS"}>
                    PFS ({total[7].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0 "
                          onClick={() => {
                            handelDetailsPopUp("PFS", rowData.Team, loginid);
                          }}
                        >
                          {rowData.PFSFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>

                <Column flexGrow={60} resizable>
                  <CustomTableHeaderCell placement={"PP"}>
                    PP ({total[8].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0"
                          onClick={() => {
                            handelDetailsPopUp("PP", rowData.Team, loginid);
                          }}
                        >
                          {rowData.PPFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>

                <Column flexGrow={100} resizable>
                  <CustomTableHeaderCell placement={"Statemnets"}>
                    Statements ({total[9].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0 "
                          onClick={() => {
                            handelDetailsPopUp(
                              "Statements",
                              rowData.Team,
                              loginid
                            );
                          }}
                        >
                          {rowData.StatementsFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={70} resizable>
                  <CustomTableHeaderCell placement={"Other"}>
                    Other ({total[10].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0"
                          onClick={() => {
                            handelDetailsPopUp("Other", rowData.Team, loginid);
                          }}
                        >
                          {rowData.OtherFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>
                <Column flexGrow={60} resizable>
                  <CustomTableHeaderCell placement={"NA"}>
                    NA ({total[11].Total / 100}){" "}
                  </CustomTableHeaderCell>
                  <CustomTableCell>
                    {(rowData: EmployeeTeamVM) => {
                      return (
                        <div
                          className="col-md-0 "
                          onClick={() => {
                            handelDetailsPopUp("NA", rowData.Team, loginid);
                          }}
                        >
                          {rowData.NAFTEBuffer}
                        </div>
                      );
                    }}
                  </CustomTableCell>
                </Column>

                <Column flexGrow={100} resizable>
                  <CustomTableHeaderCell placement={"Total"}>
                    Total (
                    {(total[0].Total +
                      total[1].Total +
                      total[2].Total +
                      total[3].Total +
                      total[4].Total +
                      total[5].Total +
                      total[6].Total +
                      total[7].Total +
                      total[8].Total +
                      total[9].Total +
                      total[10].Total +
                      total[11].Total) /
                      100}
                    )
                  </CustomTableHeaderCell>
                  <CustomTableCell dataKey="Total" />
                </Column>
              </Table>
            ) : (
              <ProcessBufferAlte />
            )}
            {filteredTeamList && (
              <div style={{ padding: 20 }}>
                <Pagination
                  prev
                  next
                  first
                  last
                  ellipsis
                  boundaryLinks
                  maxButtons={5}
                  size="md"
                  layout={["total", "-", "limit", "|", "pager", "skip"]}
                  total={filteredTeamList.length}
                  limitOptions={[10, 15, 20, 25, 30]}
                  limit={limit}
                  activePage={page}
                  onChangePage={setPage}
                  onChangeLimit={handleChangeLimit}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
